module.exports = __webpack_public_path__ + "static/media/magicbanner_sm2.53ec5fa2.jpg";